"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const defaultElementAnimation_1 = __importDefault(require("./defaultElementAnimation"));
const element_1 = require("../types/element");
function defaultVideoElement() {
    return {
        id: (0, nanoid_1.nanoid)(8),
        visible: true,
        isNew: true,
        active: false,
        playing: false,
        previewing: false,
        rewind: false,
        lock: false,
        startPoint: 0,
        loop: false,
        audio: false,
        src: null,
        type: element_1.ELEMENT_TYPE.VIDEO,
        angle: 0,
        x: 0,
        y: 0,
        width: 1280,
        height: 720,
        flipX: 1,
        flipY: 1,
        file: {
            originalWidth: 1280,
            originalHeight: 720,
            fileName: 'video_placeholder',
            videoDuration: 0,
        },
        shadow: {
            x: 0,
            y: 0,
            color: '#000000',
            blur: 0,
        },
        boxShadow: '0',
        opacity: 100,
        animationCss: 'unset',
        animationsTimeline: [(0, defaultElementAnimation_1.default)()],
    };
}
exports.default = defaultVideoElement;
